import { render } from "./SupportLandingPage.vue?vue&type=template&id=7fc164e0&scoped=true"
import script from "./SupportLandingPage.vue?vue&type=script&lang=js"
export * from "./SupportLandingPage.vue?vue&type=script&lang=js"

import "./SupportLandingPage.vue?vue&type=style&index=0&id=7fc164e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc164e0"]])

export default __exports__